module.exports = __webpack_public_path__ + "img/1557614071267794945.2c8116b9.png";